import { useQuery } from "@blitzjs/rpc"
import getCurrentUser from "app/users/queries/getCurrentUser"

export const useLegacyCurrentUser = (options = {}) => {
  const [user] = useQuery(getCurrentUser, null, {
    suspense: false,
    ...options,
  })
  return user
}
